export default function BrokerValueProp() {
  const benefits = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Wholesale Pricing',
      description: 'We buy at auction and pass the savings to you. No dealer markup games.',
      color: 'teal'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'No Pressure Sales',
      description: 'No finance office tricks. No extended warranties pushed on you. Just straight answers.',
      color: 'orange'
    },
    {
      icon: 'ri-truck-line',
      title: 'Free Delivery to Astoria',
      description: '15 minutes from Warrenton. We bring the car to your home or workplace.',
      color: 'blue'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Flat $995 Broker Fee',
      description: 'One transparent fee. No hidden charges. No doc fees stacked on top.',
      color: 'emerald'
    }
  ];

  const colorMap: Record<string, { bg: string; icon: string }> = {
    teal: { bg: 'bg-teal-100', icon: 'text-teal-600' },
    orange: { bg: 'bg-orange-100', icon: 'text-orange-600' },
    blue: { bg: 'bg-blue-100', icon: 'text-blue-600' },
    emerald: { bg: 'bg-emerald-100', icon: 'text-emerald-600' }
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Why Astoria Buyers Choose the Broker Model
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We're not a dealership. We're a licensed broker who works for you, not the bank or manufacturer.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => {
            const colors = colorMap[benefit.color];
            return (
              <div key={index} className="text-center">
                <div className={`w-16 h-16 ${colors.bg} rounded-full flex items-center justify-center mx-auto mb-4`}>
                  <i className={`${benefit.icon} text-3xl ${colors.icon}`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
                <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}